<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false, checkedGroup = []" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_people_on.png" alt="">
                <span >{{$t('groupEditTitle')}}</span>
            </h1>
            <span class="info-right">
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <manage-wrapper-component require-admin>
        <section class="animated fadeInRight">
          <div class="ibox">
            <form class="ibox-content" @submit.prevent>
              <!-- グループ名 -->
              <div class="ibox-child">
                  <div class="row">
                      <div class="form-group col-sm-12">
                          <label class="control-label">{{$t('groupNameStr')}}</label>
                          <input v-model="groupName" type="text" class="form-control" :placeholder="$t('inputGroupNameStr')">
                          <span v-if="!$v.groupName">{{$t('alertRequiredItemStr')}}</span>
                      </div>
                  </div>
              </div>
              <!-- /グループ名 -->
              <!-- メンバー -->
              <div class="ibox-child">
                  <div class="row">
                      <div class="form-group col-sm-12 info-status">
                          <div class="panel">
                              <div class="relation-body">
                                  <!-- {{this.getDeleteusers}} -->
                                  <label class="control-label status-label" for="status">{{$t('memberStr')}}</label>
                                  <div class="panel-footer info-add">
                                      <a v-if="!ownerEdit" @click="ownerEdit = true" class="btn btn-primary add-relation" href="#">{{$t('ownerEditStr')}}</a>
                                      <a v-else @click="ownerEdit = false" class="btn btn-danger add-relation" href="#">{{$t('cancelStr')}}</a>
                                      <a @click="open = true" class="btn btn-success add-relation" href="#"><i class="fa fa-plus"></i>{{$t('addMemberStr')}}</a>
                                  </div>
                              </div>
                              <div class="ibox-content search-resultview">
                                  <ul>
                                    <li v-for="user in getCheckedUsersInfo" :key="user.id" v-if="getCheckedUsersInfo" class="flex-box fl-between group-item">
                                      <div>
                                        <span v-if="user.key === groupOwnerId" class="crown-mark"><img :src="'static/img/assets/master.png'" alt=""></span>
                                        <span class="search-userimg">
                                          <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                        </span>
                                        <div class="search-userinfo">
                                          <span class="search-username">{{ user.userInfo.userName }}</span>
                                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                        </div>
                                      </div>
                                      <span class = "group-info">

                                        <span v-if="(user.key !== groupOwnerId)" class = "group-edit">
                                          <span v-if="ownerEdit" @click="onOwnerEdit(user.key)" class="btn btn-success">{{ $t('assignOwner') }}</span>
                                          <span v-else @click="onClickUserDelete(user.key)" class="btn btn-danger">{{ $t('deleteStr') }}</span>
                                        </span>
                                      </span>
                                    </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <!-- /メンバー -->
              <div class="ibox-child">
                  <div class="row okr-regist-btnset">
                      <div class="col-4"><button @click="newGroup" class="btn btn-success block m-b" :disabled="checkRegistering">{{$t('saveStr')}}</button></div>
                      <div class="col-4"><button @click="onClickCancel" type="button" class="btn btn-danger block m-b">{{ $t('cancelStr') }}</button></div>
                  </div>
              </div>
          </form>
          </div>
      </section>
    </manage-wrapper-component>
    </article>
      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false, checkedGroup = []" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">{{$t('addMembersString')}}</span>
                <span class="info-right"></span>
              </div>
                <div class="ib-sub-content">
                    <!-- ユーザー検索ボックス-チェックボックス型 -->
                  <div class="tabs-container">
                      <div class="ibox-title search-box">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserNameOrGroupNameStr')">
                                </div>
                            </div>
                        </div>
                      </div>
                      <div class="ib-sub-content">
                        <b-tabs>
                          <b-tab :title="$t('userBtnTile')" class="search-resultview">
                            <ul v-if="searchText == ''">
                              <li><label>{{$t('checkUserStrType')}}</label></li>
                              <li v-if="getVisitedUsers.length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                              <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId"><label>
                                <input type="checkbox" v-model="checkedUsers" :value="user.userId" class="checkbox public-check">
                                <span class="search-userimg">
                                  <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ user.userInfo.userName }}</span>
                                  <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                </div>
                                <span class="check-mark"></span>
                              </label></li>
                            </ul>
                            <ul v-else>
                              <li v-if="Object.keys(this.getUsersBySearchText).length === 0"><label>{{$t('notFoundUserStr')}}</label></li>
                              <li v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo && key !== getUserId"><label>
                                <input type="checkbox" v-model="checkedUsers" :value="key" class="checkbox public-check">
                                <span class="search-userimg">
                                  <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                  <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                                </span>
                                <div class="search-userinfo">
                                  <span class="search-username">{{ user.userInfo.userName }}</span>
                                  <span class="search-userdept">{{ user.userInfo.dept }}</span>
                                </div>
                                <span class="check-mark"></span>
                              </label></li>
                            </ul>
                          </b-tab>
                            <b-tab :title="$t('peopleGroupTileType')" class="search-resultview">
                                <ul v-if="searchText == ''">
                                  <li v-for="(group, key) in getGroupsBySearchText" :key="group.id" @click="addGroup(group, key)" v-if="group && Object.values(getGroupsBySearchText)[0] && group.groupName && group.members && group.ownerId"><label>
                                      <input type="checkbox" v-model="checkedGroup" :value="key" class="checkbox public-check">
                                      <div id="group1" class="ibox-child flex-box fl-between group-item">
                                          <span class="group-name">{{group.groupName}}</span>
                                          <span class="group-info">{{$t('memberStr')}}:
                                            <span class="menber-count">({{Object.keys(group.members).length}})</span>
                                          </span>
                                      </div>
                                  </label></li>
                                </ul>
                                <ul v-else>
                                  <li v-if="Object.keys(this.getGroupsBySearchText).length === 0"><label>{{$t('notFoundGroupNameStr')}}</label></li>
                                  <li v-for="(group, key) in getGroupsBySearchText" :key="group.id" @click="addGroup(group, key)" v-if="group && group.groupName && group.members && group.ownerId"><label>
                                      <input type="checkbox" v-model="checkedGroup" :value="key" class="checkbox public-check">
                                      <div id="group1" class="ibox-child flex-box fl-between group-item">
                                          <span class="group-name">{{group.groupName}}</span>
                                          <span class="group-info">{{$t('memberStr')}}:
                                            <span class="menber-count">({{Object.keys(group.members).length}})</span>
                                          </span>
                                      </div>
                                  </label></li>
                                </ul>
                            </b-tab>
                      </b-tabs>
                      </div>
                  </div>
                  <!-- /ユーザー検索ボックス-チェックボックス型 -->
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
// import NoticeItem from '@/components/Notice/NoticeItem'
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
function byte (str) {
  var length = 0
  for (var i = 0; i < str.length; i++) {
    var c = str.charCodeAt(i)
    if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
      length += 1
    } else {
      length += 2
    }
  }
  return length
}
function groupNameLengthValidation () {
  console.log('groupnameLength', byte(this.groupName))
  if (Number(byte(this.groupName)) > 24) {
    return false
  } else {
    return true
  }
}
export default {
  name: 'ManageGroupEdit',
  mixedins: [validationMixin],
  components: {
    // NoticeItem
    ManageWrapperComponent
  },
  data: function () {
    return {
      tag: 'ManageGroupEdit',
      open: false,
      checkedUsers: [],
      checkedGroup: [],
      deleteUsers: {},
      groupUsers: {},
      groups: {},
      searchText: '',
      groupName: '',
      oldMembers: [],
      groupOwnerId: '',
      ownerEdit: false,
      id: this.$route.params.id,
      isRegistering: false
    }
  },
  validations: {
    groupName: {
      required,
      groupNameLengthValidation
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ManageGroupEdit'
    },
    checkRegistering () {
      return this.isRegistering
    },
    ...mapGetters('groups/', [
      'getCurrentGroupsByText',
      'getOnlyGroupsBySearchText',
      'getGroupMembersByIds',
      'getGroupsByIds',
      'getCurrentGroups',
      'getGroupNameKeys',
      'getGroups'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUsers'
    ]),
    ...mapGetters([
      'getUserId',
      'getCurrentUser',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsManager',
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getGroupsBySearchText: function () {
      return this.getOnlyGroupsBySearchText(this.searchText)
    },
    getCheckedUsers: {
      get: function () {
        return this.checkedUsers
      },
      set: function (value) {
        this.checkedUsers.push(value)
      }
    },
    getCheckedUsersInfo: function () {
      console.log('this.getCheckedUsers::::', this.getCheckedUsers)
      let checkedUsersList = {}
      let users = {}
      users = this.getUsersByIds(this.getCheckedUsers)
      for (let userId in users) {
        checkedUsersList[userId] = users[userId]
        checkedUsersList[userId].key = userId
      }
      return checkedUsersList
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        return this.getUsers
      } else {
        return this.getUsersByText(this.searchText)
      }
    },
    checkGroupNameValide: function () {
      if (this.getGroupNameKeys) {
        console.log('in if')
        for (let name of Object.values(this.getGroupNameKeys)) {
          console.log('in for')
          if (name === this.groupName) {
            console.log('in true')
            return false
          }
        }
        return true
      } else {
        return true
      }
    },
    isManager: function () {
      return this.getMetaIsManager
    }
  },
  mounted: function () {
    // 編集用です
    if (this.isRegistering) {
      this.isRegistering = false
    }
    if (this.$route.params.item) {
      this.groupName = this.$route.params.item.groupName
      this.groupOwnerId = this.$route.params.item.ownerId
      if (this.$route.params.item.members) {
        this.checkedUsers = Object.keys(this.$route.params.item.members)
        console.log('mounted in checkedUsers::', this.checkedUsers)
        this.oldMembers = this.checkedUsers
      }
    }
  },
  methods: {
    ...mapActions('peoples/', {
      // VuexFireからのActionを読み込み
      setVisit: 'SET_VISIT_HISTORY'
    }),
    ...mapActions('groups/', {
      setNewGroup: 'SET_NEW_GROUP'
    }),
    addGroup (group, key) {
      console.log('group, key::::', group, key)
      for (let user in group.members) {
        console.log('user::::', user)
        this.getCheckedUsers = user
      }
    },
    onClickUserDelete: function (userId) {
      console.log(this.checkedUsers, userId)
      this.checkedUsers = this.checkedUsers.filter(x => x !== userId)
      // this.getDeleteusers = userId
    },
    newGroup: function () {
      const $t = this.$t
      const groupId = this.id
      this.isRegistering = true
      if (this.$v.groupName.required && this.groupName !== '' && this.groupName !== ' ' && this.groupName !== ' ' && this.$v.groupName.groupNameLengthValidation) {
        console.log('this.getCheckedUsersInfo::', this.getCheckedUsersInfo)
        let value = {
          'groupName': this.groupName,
          'members': this.parseArrayToObject(this.getCheckedUsersInfo),
          'ownerId': this.groupOwnerId,
          'groupId': groupId,
          'oldMembers': this.oldMembers
        }
        this.setNewGroup(value)
        for (let checkedUser of this.checkedUsers) {
          this.setVisit(checkedUser)
        }
        console.log('edit group!!!!!!!!!!!!!!', value)
        this.$router.push({ name: 'ManageGroups' })
      } else if (!this.$v.groupName.required) {
        // グループ名が入力されていなかったら
        this.isRegistering = false
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('noGroupNameStr'),
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          animation: false,
          customClass: 'animated fadeInUp',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem'
        })
      } else if (!this.$v.groupName.groupNameLengthValidation) {
        // グループ名の文字数制限
        this.isRegistering = false
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('warningGroupNameStr'),
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          animation: false,
          customClass: 'animated fadeInUp',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem'
        }).then(ret => {
          console.log('warningGroupNameStr', ret)
        })
      } else {
        console.log('* WTF !?')
      }
    },
    parseArrayToObject: function (object) {
      let obj = {}
      let addUserList = Object.keys(object)
      // console.log('Object.keys(object)', Object.keys(object))
      for (const i in addUserList) {
        obj[addUserList[i]] = 1
      }
      console.log('Object.keys(object)', Object.keys(object), obj)
      return obj
    },
    onClickCancel: function () {
      this.$swal({
        title: this.$t('popTitleStrType'),
        text: this.$t('popMessageStr4Type'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#f64846',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonClass: 'btn btn-success',
        animation: false,
        customClass: 'animated fadeInUp',
        // customClass: 'animated flipInX',
        width: '35rem',
        position: 'center',
        // toast: true,
        allowOutsideClick: false,
        padding: '2rem'
        // timer: 4000
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: 'ManageGroups' })
        }
      })
    },
    onOwnerEdit: function (userId) {
      this.groupOwnerId = userId
      this.ownerEdit = false
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.ibox-child
span.crown-mark {
  top: 1.0rem;
  left: -1.8rem;
    /* text-shadow: 16px -6px black; */
}
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageGroupEdit.vue